import { render, staticRenderFns } from "./ValidationInput.vue?vue&type=template&id=c85d438c&scoped=true"
import script from "./ValidationInput.vue?vue&type=script&lang=js"
export * from "./ValidationInput.vue?vue&type=script&lang=js"
import style0 from "./ValidationInput.vue?vue&type=style&index=0&id=c85d438c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d438c",
  null
  
)

export default component.exports